export const formatNumberWithDigit = (
  number: number,
  minDigit = 2,
  maxDigit?: number
): string => {
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: minDigit,
    maximumFractionDigits: maxDigit,
  }).format(number);
};
